export default __webpack_public_path__ + "static/media/stock-clients.2d7e9958.svg";